import {
  BellIcon,
  CalendarIcon,
  BanknotesIcon,
  UsersIcon,
  StarIcon,
  UserPlusIcon,
  ArrowsUpDownIcon,
  KeyIcon,
  ClockIcon,
  ArrowPathIcon,
} from '@heroicons/react/24/outline';

export const TYPE_ICONS = {
  convocation: CalendarIcon,
  cotisation_reminder: BanknotesIcon,
  cotisation_due: BanknotesIcon,
  cotisation_paid: BanknotesIcon,
  cotisation_overdue: BanknotesIcon,
  tat_request: UsersIcon,
  tat_response: UsersIcon,
  recommendation_received: StarIcon,
  member_invited: UserPlusIcon,
  tier_change_request: ArrowsUpDownIcon,
  password_reset: KeyIcon,
  trial_ending: ClockIcon,
  trial_expired: ClockIcon,
  renewal_due: ArrowPathIcon,
  renewal_overdue: ArrowPathIcon,
};

export const DEFAULT_ICON = BellIcon;
